import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";

export const CreateProgramTemplateProfileWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-container {
    padding: 0px 0px 16px 16px;

    ${responsive.MOBILE`
       padding: 0px 8px 16px 8px !important;
    `}
  }

.program-name {
  position: relative;

  &.non-mandatory-language {
    .mui-label {
      max-width: 100px;
    }
  }
}
  .manage-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    position: absolute;
    right: 0px;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    color: ${COLORS.primary_light_blue};
  }
`;
